import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../AllVon/VonHeader/assets/logo.png";
import NotificationBell from "../NotificationBell";
import Icon from "./Icon";

const QUERY = "(max-width: 760px)";

/** True on phone widths (the same breakpoint as the stylesheet). */
export function useMobile() {
  const get = () => typeof window !== "undefined" && window.matchMedia(QUERY).matches;
  const [mobile, setMobile] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const on = () => setMobile(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return mobile;
}

/**
 * Phone navigation for both dashboards: a top bar (logo, notifications, Menu) that slides the full
 * sidebar in from the left, plus, for students, a bottom tab bar with the main pages and "More".
 * Renders nothing on wider screens.
 */
export default function MobileNav({ open, setOpen, tabs = null, pathname }) {
  const mobile = useMobile();
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [open, setOpen]);
  if (!mobile) return null;

  return (
    <>
      <header className="m-top">
        <Link to="/" className="logo"><img src={Logo} alt="E1X Academy" /></Link>
        <span style={{ flex: 1 }} />
        <NotificationBell />
        <button type="button" className="m-menu" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} onClick={() => setOpen(!open)}>
          {open ? <span aria-hidden="true" style={{ fontSize: 18, lineHeight: 1 }}>✕</span> : <Icon name="menu" size={22} />}
        </button>
      </header>
      {open && <div className="m-scrim" onClick={() => setOpen(false)} />}
      {tabs && (
        <nav className="m-tabs" aria-label="Main">
          {tabs.map(([label, to, icon, match]) => (
            <Link key={to} to={to} className={!open && (match ? match(pathname) : pathname.startsWith(to)) ? "on" : ""}><Icon name={icon} size={21} /><span>{label}</span></Link>
          ))}
          <button type="button" className={open ? "on" : ""} onClick={() => setOpen(!open)} aria-expanded={open}><Icon name="dots" size={21} /><span>More</span></button>
        </nav>
      )}
    </>
  );
}
